<cov-side-panel-grid>
  <div ngProjectAs="header" class="d-flex flex-column gap-4">
    <h2>{{ 'inquiries.sideDrawer.contactPanel.title' | transloco }}</h2>
    <p>
      @if (hasOrder()) {
        {{ 'inquiries.sideDrawer.contactPanel.subTitleWithOrder' | transloco }}
      } @else {
        {{ 'inquiries.sideDrawer.contactPanel.subTitleWithoutOrder' | transloco }}
      }
    </p>
  </div>
  <div ngProjectAs="content">
    <div class="d-flex flex-column gap-4 pr-4">
      @if (hasOrder()) {
        <cov-expandable [bodyContent]="orderInfo" [headerContent]="orderInfoHeader">
          <ng-template #orderInfoHeader>
            <div class="d-flex gap-2 w-100">
              <span class="cov-fs-strong">
                {{ 'inquiries.sideDrawer.contactPanel.orderInfo.order'| transloco }}
              </span>
              <span class="content-text">{{
                'inquiries.sideDrawer.contactPanel.orderInfo.orderData'| transloco:{
                orderNumber: order()?.orderId,
                itemNumber: order()?.orderItemPosition ?? null | removeLeadingZeros
              }
              }}</span>
            </div>
          </ng-template>
          <ng-template #orderInfo>
            <cov-inquiry-order-info [order]="order()" />
          </ng-template>
        </cov-expandable>

        <div class="d-flex flex-column gap-4 my-4">
          <cov-drag-drop-file-select
            (filesDropped)="addFiles($event)"
            [maxFileSize]="MAX_FILE_SIZE"
            [allowedFormats]="ALLOWED_FORMATS"
            [allowedFormatsString]="ALLOWED_FORMATS_STRING"
            [allowedFileExtensions]="ALLOWED_FILE_EXTENSIONS"
            (fileError)="onFileError($event)"
          />
          <p class="cov-fs-muted">
            {{ 'inquiries.sideDrawer.fileAttachments.dragDropSubline'| transloco }}
          </p>
          @if (attachedFiles().length > 0) {
            <cov-inquiry-attached-files
              [files]="attachedFiles()"
              (fileDeleted)="deleteFile($event)"
            ></cov-inquiry-attached-files>
          }
        </div>
      }

      @if (form(); as form) {
        <form class="d-flex flex-column gap-10 mt-6 px-1" [formGroup]="form">
          @if (!hasOrder()) {
            <!-- CSR contact -->
            @if (csrEmailControl) {
              <mat-form-field>
                <label for="csrContact">
                  {{ 'inquiries.sideDrawer.contactPanel.form.label.csrContact'|transloco }}
                </label>
                <select id="csrContact" matNativeControl [formControl]="csrEmailControl">
                  <option [ngValue]="''">
                    {{ 'inquiries.sideDrawer.contactPanel.form.pleaseSelectContact'|transloco }}
                  </option>
                  @for (info of csrInfos(); track info.mail) {
                    <option [ngValue]="info.mail">
                      {{ info.mail }}
                    </option>
                  }
                </select>
              </mat-form-field>
            }
            <!--SoldTo Select -->

            @if (soldTos(); as soldToList) {
              <mat-form-field>
                <label for="soldTo">
                  {{ 'inquiries.sideDrawer.contactPanel.form.label.soldTo'|transloco }}
                </label>
                <select id="soldTo" matNativeControl [formControl]="soldToControl">
                  <option [ngValue]="''">
                    {{ 'inquiries.sideDrawer.contactPanel.form.pleaseSelectSoldTo'|transloco }}
                  </option>
                  @for (address of soldToList; track address.sapCustomerID) {
                    <option [ngValue]="address.sapCustomerID">
                      {{ address.companyName }} {{ address.town }} {{ address.country?.name }}
                    </option>
                  }
                </select>
              </mat-form-field>
            }
          }
          <mat-form-field>
            <label for="message">
              {{ 'inquiries.sideDrawer.contactPanel.form.label.message' | transloco }}
            </label>
            <textarea
              rows="4"
              [placeholder]="translate('inquiries.sideDrawer.contactPanel.form.label.messagePlaceholder')"
              id="message"
              matNativeControl
              formControlName="message"
            ></textarea>
          </mat-form-field>
        </form>
      }
    </div>
  </div>
  <div ngProjectAs="footer">
    <div class="d-flex justify-content-between">
      <cov-button [buttonType]="ButtonType.SECONDARY" (click)="cancelInquiry.emit(PageId.INTRO)">
        {{ 'global.ui.button.cancel' | transloco }}
      </cov-button>
      <cov-button
        class="send-button"
        [buttonType]="ButtonType.PRIMARY"
        (click)="submit()"
        [disabled]="disableSendButton()"
      >
        <div class="d-flex gap-2">
          <span>{{ 'global.ui.button.send' | transloco }}</span>
          @if (inquiryService.inquirySubmitLoading()) {
            <mat-spinner color="white" [diameter]="16" />
          }
        </div>
      </cov-button>
    </div>
  </div>
</cov-side-panel-grid>
